<template>
  <RangedReports
    :reportData="reportData"
    :reportTotals="reportTotals"
    :chartData="chartData"
    :currentRange="currentRange"
    :startDate="startDate"
    :loading="$apollo.loading"
    day
    @change="onRangeChange"
  />
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import dayjs from '@/dayjs';
import filters from '@/filters';
import { useLocationsStore } from '@/stores/locations';
import RangedReports from '../components/RangedReports.vue';

export default defineComponent({
  components: {
    RangedReports,
  },
  setup() {
    return {
      filters,
    };
  },
  data() {
    return {
      dailyReport: {},
      reportTotals: {},
      reportData: [],
      chartTotals: [],
      chartOrders: [],
      startDate: dayjs().format(),
      chartLabels: [],
    };
  },
  apollo: {
    dailyReport: {
      query: gql`
        query dailyReport(
          $startDate: DateTime
          $locationId: ID
          $dataScope: DataScope
        ) {
          dailyReport(
            startDate: $startDate
            locationId: $locationId
            dataScope: $dataScope
          ) {
            data {
              date
              bank
              cash
              cheque
              coupon
              creditcard
              date
              discount
              giftcard
              online
              orders
              pin
              prepaidCard
              total
              totalInc
              transactions
              treatwellOnlinePayment
              vat
              pos
              other
              gifty
            }
            chartData {
              orders
              totals
            }
            totals {
              total
              totalBank
              totalCash
              totalCheque
              totalCoupon
              totalCreditcard
              totalGiftcard
              totalInc
              totalOnline
              totalOrders
              totalPin
              totalPrepaidCard
              totalTransactions
              totalTreatwellOnlinePayment
              totalPos
              totalOther
              totalGifty
              totalVat
            }
          }
        }
      `,
      variables() {
        return {
          startDate: this.startDate,
          locationId: this.locationId,
          dataScope: this.dataScope,
        };
      },
      result() {
        this.reportTotals = this.dailyReport.totals;
        this.reportData = this.dailyReport.data;
        this.chartTotals = this.dailyReport.chartData?.totals || [];
        this.chartOrders = this.dailyReport.chartData?.orders || [];
        this.chartLabels =
          this.getLabels(this.dailyReport.chartData?.totals) || [];
      },
    },
  },
  computed: {
    ...mapState(useLocationsStore, ['locationId', 'dataScope']),
    currentRange() {
      const range = dayjs(this.startDate).format();
      return this.filters.date(range, { format: 'monthYear' });
    },
    chartData() {
      return {
        data: [this.chartOrders, this.chartTotals],
        labels: this.chartLabels,
      };
    },
  },
  methods: {
    getLabels(totals) {
      return [...Array(totals.length)].map((_, index) => {
        const date = dayjs(this.startDate)
          .startOf('month')
          .add(index, 'days')
          .format();
        return this.filters.date(date, { format: 'monthDay' });
      });
    },
    onRangeChange(date) {
      this.startDate = date.format();
    },
  },
});
</script>
